import { BoxProps, chakra } from '@chakra-ui/react';

export const Card = chakra('div', {
  baseStyle: {
    borderRadius: '8px',
    backgroundColor: 'white',
    shadow: 'base',
  },
});

export type CardProps = BoxProps;
